import React from "react";
import { FiRefreshCw } from "react-icons/fi";
import { usePageRefreshContext } from "../../context/PageRefreshContext";

const RefreshPageButton = ({
  compact = false,
  className = "",
  label = "Refresh",
}) => {
  const ctx = usePageRefreshContext();
  if (!ctx) return null;

  const { refresh, refreshing } = ctx;

  if (compact) {
    return (
      <button
        type="button"
        onClick={refresh}
        disabled={refreshing}
        aria-label="Refresh page"
        title="Refresh"
        className={`shrink-0 flex items-center justify-center w-10 h-10 rounded-full hover:bg-white/10 active:bg-white/15 transition-colors disabled:opacity-50 ${className}`}
      >
        <FiRefreshCw
          className={`text-lg ${refreshing ? "animate-spin" : ""}`}
        />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={refresh}
      disabled={refreshing}
      className={`inline-flex items-center justify-center gap-1.5 h-9 px-3 rounded-xl border border-line bg-card text-main text-xs font-bold shadow-soft hover:bg-brandSoft hover:border-main/30 transition-colors disabled:opacity-60 active:scale-[.98] ${className}`}
    >
      <FiRefreshCw size={14} className={refreshing ? "animate-spin" : ""} />
      {refreshing ? "Refreshing…" : label}
    </button>
  );
};

export default RefreshPageButton;
